import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  customer: {
    whiteSpace: "nowrap",
  },
}));

export default useStyles;
